import { WebSocketMessage } from '../types';

export class WebSocketService {
  private ws: WebSocket | null = null;
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;
  private reconnectDelay = 1000;
  
  public onMessage: ((data: WebSocketMessage) => void) | null = null;
  public onConnectionChange: ((status: 'connected' | 'disconnected' | 'connecting') => void) | null = null;

  constructor() {
    this.connect();
  }

  private connect() {
    if (this.onConnectionChange) {
      this.onConnectionChange('connecting');
    }

    // Always use production WebSocket URL
    const wsUrl = 'wss://clipshare.jtechdev.cz/ws';
    
    this.ws = new WebSocket(wsUrl);

    this.ws.onopen = () => {
      console.log('WebSocket connected to:', wsUrl);
      this.reconnectAttempts = 0;
      if (this.onConnectionChange) {
        this.onConnectionChange('connected');
      }
    };

    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (this.onMessage) {
        this.onMessage(data);
      }
    };

    this.ws.onclose = () => {
      console.log('WebSocket disconnected');
      if (this.onConnectionChange) {
        this.onConnectionChange('disconnected');
      }
      this.attemptReconnect();
    };

    this.ws.onerror = (error) => {
      console.error('WebSocket error:', error);
      if (this.onConnectionChange) {
        this.onConnectionChange('disconnected');
      }
    };
  }

  private attemptReconnect() {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      console.log(`Reconnect attempt ${this.reconnectAttempts}/${this.maxReconnectAttempts}`);
      
      setTimeout(() => {
        this.connect();
      }, this.reconnectDelay * this.reconnectAttempts);
    }
  }

  public async send(data: any) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(data));
    } else {
      throw new Error('WebSocket not connected');
    }
  }

  public isConnected(): boolean {
    return this.ws?.readyState === WebSocket.OPEN;
  }

  public disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
}